<template>
  <article class="flex items-center px-4">
    <EditorUiConfigButton class="mr-2" @toggle-visibility="toggleVisibility" @toggle-display="toggleDisplay" />
    <slot />
  </article>
</template>

<script lang="ts" setup>
const emit = defineEmits(['toggle-visibility', 'toggle-display'])

function toggleVisibility(state: boolean) {
  emit('toggle-visibility', state)
}

function toggleDisplay(state: boolean) {
  emit('toggle-display', state)
}
</script>

<style lang="stylus" scoped></style>
